import AssessmentTemplatesList from "@/views/shared/AssessmentTemplatesList";

function Service() {
    return <AssessmentTemplatesList title="pages.my_assessments.services" listType="ALL" />;
}
export default Service;
